import cn from 'clsx'
import s from '@styles/ui/Card/Card.module.css'
import React from 'react'

export interface CardProps {
  children: any
  disabled?: boolean
  expanded?: boolean
  loading?: boolean
}

const Card: React.FC<CardProps> = ({ children,loading, expanded, disabled }) => {
  const rootClassName = cn(
    s.root,
    {
      [' hover:shadow-all-round-strong']: !disabled,
      ['opacity-60 ']: disabled,
      ['h-full w-full ']: expanded,
    },
    'shadow-all-round transition-all duration-200 rounded-lg bg-white '
  )

  return <div className={rootClassName}>{children}</div>
}

export default Card
